import get from 'lodash.get'

export const getUser = state => get(state, 'user', {})
export const getUserEmail = state => get(getUser(state), 'email', '')

export const getUserBroker = state => get(getUser(state), 'brokerage', {})
export const getUserBrokerId = state => get(getUserBroker(state), 'brokerId', '')
export const getUserBrokerName = state => get(getUserBroker(state), 'name', '')
